'use strict';

angular.module('amexReconciliationApp')
  .component('summaryApprovalsHeader', {
    templateUrl: 'scripts/views/components/summary-approvals-header.html',
    controller: function () {

    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/summaryApprovalsHeader.js
// module id = 481
// module chunks = 0